import { styled, Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import CbButton from '../components/Buttons/CbButton';

const NotFound = () => {
  const history = useHistory();

  return (
    <FlexBox style={{ paddingTop: '3rem' }}>
      <FlexBox style={{ flexDirection: 'column', maxWidth: 1400 }}>
        <img
          src="images/sad_lost_cow.png"
          alt=""
          style={{ minHeight: '36rem' }}
        />
        <h1>Far from home? You look a little lost.</h1>
        <h3 style={{ marginTop: 0 }}>
          We are unable to locate the page you're looking for. Here are some
          options:
        </h3>
        <Box display="flex" style={{ paddingTop: '1.5rem' }}>
          <CbButton styleName="ctaButton" onClick={history.goBack}>
            Go Back
          </CbButton>
        </Box>
      </FlexBox>
    </FlexBox>
  );
};

const FlexBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export default NotFound;
